import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";
import { DollarSign } from "lucide-react";

export default function AdminRevenue() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/revenue").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const total = (data?.timeline || []).reduce((a, x) => a + x.amount, 0);
  const formatted = data?.timeline?.map((x) => ({ ...x, date: x.date.slice(5) })) || [];

  return (
    <div className="p-8 max-w-[1600px] mx-auto">
      <div className="kr-overline text-[#8A52FF]">[ REVENUE ]</div>
      <h1 className="font-display text-4xl mt-2 tracking-tight" data-testid="admin-revenue-title">Revenue dashboard</h1>
      <p className="text-white/55 text-sm mt-1.5">Last 30 days of paid checkouts and plan distribution.</p>

      <div className="mt-10 grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-8 kr-card p-6">
          <div className="flex items-center justify-between">
            <div className="kr-overline">[ 30-DAY TIMELINE ]</div>
            <div className="font-display text-2xl">${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          </div>
          <div className="h-64 mt-4 min-h-[260px] w-full">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={formatted}>
                <XAxis dataKey="date" stroke="#52525B" fontSize={10} />
                <YAxis stroke="#52525B" fontSize={10} />
                <Tooltip contentStyle={{ background: "#0A0A0E", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", fontSize: 12 }} />
                <Line type="monotone" dataKey="amount" stroke="#00E5FF" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-4 kr-card p-6">
          <div className="kr-overline">[ BY PLAN ]</div>
          <div className="h-64 mt-4 min-h-[260px] w-full">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data?.by_plan || []}>
                <XAxis dataKey="plan" stroke="#52525B" fontSize={10} />
                <YAxis stroke="#52525B" fontSize={10} />
                <Tooltip contentStyle={{ background: "#0A0A0E", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", fontSize: 12 }} />
                <Bar dataKey="amount" fill="#8A52FF" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="mt-6 kr-card p-6">
        <div className="kr-overline">[ RECENT TRANSACTIONS ]</div>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-white/40 border-b border-white/5">
                <th className="text-left p-2 font-mono text-[10px] tracking-wider uppercase">Email</th>
                <th className="text-left p-2 font-mono text-[10px] tracking-wider uppercase">Plan</th>
                <th className="text-right p-2 font-mono text-[10px] tracking-wider uppercase">Amount</th>
                <th className="text-left p-2 font-mono text-[10px] tracking-wider uppercase">Status</th>
                <th className="text-left p-2 font-mono text-[10px] tracking-wider uppercase">Date</th>
              </tr>
            </thead>
            <tbody>
              {(data?.recent_transactions || []).map((t) => (
                <tr key={t.tx_id} className="border-b border-white/5">
                  <td className="p-2">{t.user_email}</td>
                  <td className="p-2 capitalize">{t.plan}</td>
                  <td className="p-2 text-right font-mono">${(t.amount || 0).toFixed(2)}</td>
                  <td className="p-2"><span className="px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider border border-[#34D399]/40 text-[#34D399]">{t.payment_status}</span></td>
                  <td className="p-2 text-xs text-white/50">{new Date(t.created_at).toLocaleString()}</td>
                </tr>
              ))}
              {(!data?.recent_transactions || data.recent_transactions.length === 0) && (
                <tr><td colSpan={5} className="p-8 text-center text-white/40">No transactions yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
